import React from 'react';
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

const Graph = ({ data }) => {
    return (
        <ResponsiveContainer width={'100%'} height={300}>
            <LineChart
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 5, right: 30, left: 20, bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis yAxisId="left" />
                <YAxis yAxisId="right" orientation="right"/>
                <Tooltip/>
                <Legend/>
                <Line yAxisId="left" type="linear" dataKey="requests" stroke="#ff0000" dot={{ stroke: '#ff0000', strokeWidth: 3 }} activeDot={{ stroke: '#ff0000', strokeWidth: 3 }} strokeWidth={3}/>
                <Line yAxisId="left" type="linear" dataKey="responses" stroke="#008000" dot={{ stroke: '#008000', strokeWidth: 3 }} activeDot={{ stroke: '#008000', strokeWidth: 3 }} strokeWidth={3} />
                <Line yAxisId="right" type="linear" dataKey="err" stroke="#5c00e6" dot={{ stroke: '#5c00e6', strokeWidth: 3 }} activeDot={{ stroke: '#5c00e6', strokeWidth: 3 }} strokeWidth={3} />
            </LineChart>
        </ResponsiveContainer>
    );
}

export default Graph;


// WEBPACK FOOTER //
// ./src/scenes/BidderFillRate/components/Graph/index.js